import React from 'react' // eslint-disable-line no-unused-vars
import HeroImageHome from './HeroImageHome'
import HomeContentProfessional from './HomeContentProfessional'
import HomeContentPatient from './HomeContentPatient'
import '../../css/forms/default-forms.css'
import SiteMessages from '../siteMessages/SiteMessages'
import StaticConfig from '../StaticConfig'
import history from '../../history'
import { connect } from 'react-redux'

import { initializeReferenceData } from '../../helpers/InitializeStoreData'
import { ABBVIE_EMPLOYEE, PATIENT } from '../../constants'

import { referenceData, selectedCountry, listOfCountries } from '../../actions/referenceData'
import { setPermissionAction } from '../../actions/config'
import { switchLanguage } from '../language/actions'
import { api } from '../index.api'
import Footer from '../Footer'
import { triggerSSO } from '../InitiateSSO'
import { notify } from 'reapop'

class Home extends React.Component {
  constructor (props) {
    super(props)

    this.data = this.props.data
    this.state = {
      messageItems: [],
      UType: ''
    }

    this._getCountryList = this._getCountryList.bind(this)
    this._ssoHandler()

    this.loadSiteMessages = this.loadSiteMessages.bind(this)
  }

  componentDidMount () {
    this.loadSiteMessages()
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.pageContent !== this.props.pageContent || prevProps.reference !== this.props.reference) {
      this.loadSiteMessages()
    }
  }

  loadSiteMessages () {
    let userLanguage = 'en'
    const languageContent = this.props.pageContent.content
    if (languageContent && languageContent.lang) {
      userLanguage = languageContent.lang
    }

    const userCountry = this.props.reference ? this.props.reference.SelectedCountry : null
    if (!userCountry) {
      return
    }

    api.siteMessages(
      {
        languageCode: userLanguage,
        countryCode: userCountry.abbrevation
      },
      this._loadSiteMessagesSuccessHandler.bind(this),
      this._loadSiteMessagesFailureHandler.bind(this)
    )
  }

  _loadSiteMessagesSuccessHandler = (response) => {
    if (response.status === 200) {
      response.json().then(responseJson => {
        this.setState({ messageItems: responseJson })
      })
    } else if (response.status === 401) {
      this._showNotification(
        'Error',
        'You are not authorized to perform this action. Please log in again.',
        'error'
      )
      setTimeout(() => triggerSSO(this.props.pageContent.content.lang), 3000)
    } else {
      this._showNotification(
        'Error',
        'Error occurred while submitting query to get site messages for home page',
        'error'
      )
    }
  }

  _showNotification = (title, message, status) => {
          const { notify } = this.props
          notify({
            title,
            message,
            status,
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          })
        }

  _loadSiteMessagesFailureHandler = (error) => {
    this._showNotification('Error', 'Unexpected error occurred!!', 'error')
  }

  _ssoHandler = () => {
    const isLogin = sessionStorage.getItem('loginBySSO')
    if (isLogin) {
      sessionStorage.removeItem('loginBySSO')
      this._getCountryList()
      this._getUserCountryAndInitialiseStore()
    }
  }

  _getCountryList = () => {
    api.fetchCountriesList(data => { this.props.listOfCountries(data.COUNTRY) })
  }

  _getUserCountryAndInitialiseStore = () => {
    api.fetchInternalEmployeeCountry(this._fetchEmployeeCountrySuccessHandler.bind(this))
  }

  _fetchEmployeeCountrySuccessHandler = resp => {
    if (resp.status === 200) {
      resp.json().then(data => {
        const selectedCountry = data.Country
        // set sso country in static context as it will not be changed
        StaticConfig.Context.ssoCountry = selectedCountry
        const selectedLanguage = sessionStorage.getItem('userLanguage')
        this.setState({ UType: ABBVIE_EMPLOYEE })

        const actionDispatchers = {
          selectedCountry: this.props.selectedCountry,
          referenceData: this.props.referenceData,
          listOfCountries: this.props.listOfCountries,
          switchLanguage: this.props.switchLanguage,
          setPermissionAction: this.props.setPermissionAction
        }
        const isConference = false

        initializeReferenceData(selectedCountry,
          ABBVIE_EMPLOYEE,
          selectedLanguage,
          actionDispatchers,
          isConference)
        sessionStorage.clear()
      })
    } else {
      sessionStorage.clear()
      history.push({
        pathname: '/errorPage',
        state: { errorMessage: 'Country not Found.' }
      })
    }
  }

  render () {
    const languageContent = this.props.pageContent.content
    const userType = this.props.reference ? this.props.reference.UserType : null
    return (
      <div className='page-container'>
        <div className='page-content'>
          <SiteMessages
            messageItems={this.state.messageItems}
            sessionLanguage={languageContent.lang}
            languageContent={languageContent}
          />
          <HeroImageHome
            languageContent={languageContent.page.HOME}
            userType={userType}
          />
          {
            userType === PATIENT
              ? <HomeContentPatient languageContent={languageContent.page.HOME.patient}/>
              : <HomeContentProfessional permissions={this.props.permissions} messageItems={this.state.messageItems} _showNotification={this._showNotification}/>
          }
        </div>
        <Footer submitInquiry={false} showHomeFooter={userType !== PATIENT} />
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    pageContent: state.pageContent,
    permissions: state.permissions,
    reference: getReferenceData(state.referenceData)
  }
}

const getReferenceData = (referenceData) => {
  const data = referenceData.filter(item => item.type === 'REF_DATA').pop()
  return data ? data.referenceData : null
}

export default connect(mapStateToProps,
  { selectedCountry, referenceData, listOfCountries, switchLanguage, setPermissionAction, notify })(Home)



// WEBPACK FOOTER //
// ./src/mi-app/home/Home.js